import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { EventService, RoutingService, createFrom, TranslatePipe } from '@spartacus/core';
import { SloanCpqProjectService } from '../../../../../app/common/services/sloan-cpq-project.service';
import { Project } from '../../../../../app/models/projects.model';
import { SloanCpqOnClickEvent } from '../../../../../app/store/custom-spartacus-events';
import { SloanCpqProjectDetailsComponent } from '../../sloan-cpq-project-details/sloan-cpq-project-details.component';
import { SloanCpqConfirmDialogService } from '../../../../../app/common/component/sloan-cpq-confirm-dialog/sloan-cpq-confirm-dialog.service';

@Component({
    selector: 'sloan-cpq-project-item',
    templateUrl: './sloan-cpq-project-item.component.html',
    styleUrls: ['./sloan-cpq-project-item.component.scss'],
    imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, TranslatePipe]
})
export class SloanCpqProjectItemComponent implements OnInit {
  imageUrl = '/images/';
  modalRef;
  @Input() project: Project;
  triggerElement: HTMLElement;
  constructor(
    public routeService: RoutingService,
    private modalService: NgbModal,
    private sloanCpqProjectService: SloanCpqProjectService,
    private confirmationDialogService: SloanCpqConfirmDialogService,
    private events: EventService
  ) {}

  ngOnInit(): void {}

  sloanCPQOnClickEvent(title): void {
    this.events.dispatch(createFrom(SloanCpqOnClickEvent, { title: title }));
  }

  goToConfigurators() {
    this.routeService.go({ cxRoute: 'configurationlist', params: { code: this.project.code } });
  }

  archive() {
    this.confirmationDialogService
      .confirm('projects.projectItem.archive', 'projects.projectItem.archiveConfirmMsg')
      .then((confirmed) => {
        if (confirmed) {
          this.sloanCpqProjectService.archiveProject(this.project.code);
        } else {
          console.log(confirmed);
        }
      });
  }

  projectDetails() {
    this.triggerElement = document.activeElement as HTMLElement;
    let modalInstance: any;
    this.modalRef = this.modalService.open(SloanCpqProjectDetailsComponent);
    modalInstance = this.modalRef.componentInstance;
    modalInstance.projectDetail = this.project;

    requestAnimationFrame(() => {
      const modalWindow = document.querySelector('ngb-modal-window') as HTMLElement;
      const modalBackdrop = document.querySelector('ngb-modal-backdrop') as HTMLElement;

      modalWindow?.classList.add('show');
      modalBackdrop?.classList.add('show');

      const firstInput = modalWindow?.querySelector('input') as HTMLElement;
      firstInput?.focus();
    });
  }
}
